import { api } from 'helpers/api/apiCore';
import {
  HeaderInfoResponse,
  StrategyPerformance,
} from 'api/types/httpsTypes/marketplace-performance';

export interface UseHeaderInfoValues {
  botId?: string;
}

export const MarketplacePerformanceService = {
  getHeaderInfo: async ({ botId }: UseHeaderInfoValues) => {
    return api.get<HeaderInfoResponse>(
      `/api/v2/marketplace/strategy/main/${botId || ''}`
    );
  },
  getStatsInfo: async ({ botId }: UseHeaderInfoValues) => {
    const response = await api.get<StrategyPerformance>(
      `/api/v2/marketplace/strategy/performance/${botId || ''}`
    );
    return response.data;
  },
};
